import { createRequestConstantNames } from 'store/util/createConstants';
import cc from 'store/util/createReduxConstant';

export const [
  FETCH_MEMBERSHIP_TYPES_BY_COMPANY,
  FETCH_MEMBERSHIP_TYPES_BY_COMPANY_SUCCESS,
  FETCH_MEMBERSHIP_TYPES_BY_COMPANY_FAIL,
] = createRequestConstantNames(cc('FETCH_MEMBERSHIP_TYPES_BY_COMPANY'));
